<template>
    <!-- 外層容器，使用與 ContactPage 類似的 3D 效果 -->
    <div class="login-container" ref="loginBlock">
        <!-- 主要卡片：左右分佈 -->
        <div class="login-card">
            <!-- 左側：展示區域（可放品牌 Logo / Banner / 簡介 等） -->
            <div class="login-left">
                <h1>歡迎回來</h1>
                <p>
                    登入 {{$Settings.COMPANY_NAMEN}} 後，即可享有更多服務以及快速結帳體驗，
                    盡情享受購物的樂趣！
                </p>
                <!-- 懶加載示例：imagePath + v-lazy -->
                <img 
                  ref="image" 
                  class="login-image" 
                  loading="lazy"
                  :src="loginImg ? `${loginImg}` : null"
                  :alt="`${$COMPANY_NAME} (${$COMPANY_NAMEn}) 即可享有更多服務以及快速結帳體驗！`" 
                />
            </div>

            <!-- 右側：登入表單 -->
            <div class="login-right">
                <!-- 1. 快速登入區（在手機版會排到最上面） -->
                <div class="quick-login">
                    <h3>快速登入</h3>
                    <div class="quick-login-buttons">
                        <!-- Facebook -->
                        <!-- <button class="social-btn fb-btn" @click="handleFacebookLogin">
                            <svg data-v-054dcc2b="" class="floating-icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path data-v-054dcc2b="" d="M24.146 12.073C24.146 5.40365 18.7424 0 12.073 0C5.40365 0 0 5.40365 0 12.073C0 18.0988 4.41493 23.0935 10.1866 24V15.563H7.11968V12.073H10.1866V9.41306C10.1866 6.38751 11.9878 4.71627 14.7466 4.71627C16.0678 4.71627 17.4494 4.95189 17.4494 4.95189V7.92146H15.9267C14.4273 7.92146 13.9594 8.85225 13.9594 9.8069V12.073H17.3077L16.7723 15.563H13.9594V24C19.7311 23.0935 24.146 18.0988 24.146 12.073Z" fill="currentColor"></path></svg>
                            Facebook
                        </button> -->

                        <!-- Google -->
                        <button class="social-btn google-btn" @click="handleGoogleAuthCodeLogin">
                            <!-- SVG 版本的 Google 圖示 -->
                            <svg class="NEH9Ef" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
                                viewBox="0 0 40 48" aria-hidden="true" jsname="jjf7Ff">
                                <path fill="#4285F4"
                                    d="M39.2 24.45c0-1.55-.16-3.04-.43-4.45H20v8h10.73c-.45 2.53-1.86 4.68-4 6.11v5.05h6.5c3.78-3.48 5.97-8.62 5.97-14.71z" />
                                <path fill="#34A853"
                                    d="M20 44c5.4 0 9.92-1.79 13.24-4.84l-6.5-5.05C24.95 35.3 22.67 36 20 36c-5.19 0-9.59-3.51-11.15-8.23h-6.7v5.2C5.43 39.51 12.18 44 20 44z" />
                                <path fill="#FABB05"
                                    d="M8.85 27.77c-.4-1.19-.62-2.46-.62-3.77s.22-2.58.62-3.77v-5.2h-6.7C.78 17.73 0 20.77 0 24s.78 6.27 2.14 8.97l6.71-5.2z" />
                                <path fill="#E94235"
                                    d="M20 12c2.93 0 5.55 1.01 7.62 2.98l5.76-5.76C29.92 5.98 25.39 4 20 4 12.18 4 5.43 8.49 2.14 15.03l6.7 5.2C10.41 15.51 14.81 12 20 12z" />
                            </svg>
                            Google
                        </button>

                        <!-- LINE -->
                        <button class="social-btn line-btn" @click="handleLineLogin">
                            <!-- <img 
                              ref="image" 
                              v-lazy="{ src: imagePath('appline256x256.webp') }" 
                              :alt="`${$COMPANY_NAME} (${$COMPANY_NAMEn}) LINE 快速登入！`"
                              style="max-width: 32px;" 
                            /> -->
                             <svg data-v-054dcc2b="" class="floating-icon" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path data-v-054dcc2b="" d="M14.7228 9.225V13.0339C14.7228 13.1304 14.6478 13.2054 14.5514 13.2054H13.9406C13.8817 13.2054 13.8281 13.1732 13.8014 13.1357L12.0549 10.7786V13.0393C12.0549 13.1357 11.9799 13.2107 11.8835 13.2107H11.2728C11.1764 13.2107 11.1014 13.1357 11.1014 13.0393V9.23036C11.1014 9.13393 11.1764 9.05893 11.2728 9.05893H11.8781C11.9317 9.05893 11.9906 9.08572 12.0174 9.13393L13.7639 11.4911V9.23036C13.7639 9.13393 13.8389 9.05893 13.9353 9.05893H14.546C14.6424 9.05357 14.7228 9.13393 14.7228 9.225V9.225ZM10.3299 9.05357H9.71921C9.62278 9.05357 9.54778 9.12857 9.54778 9.225V13.0339C9.54778 13.1304 9.62278 13.2054 9.71921 13.2054H10.3299C10.4264 13.2054 10.5014 13.1304 10.5014 13.0339V9.225C10.5014 9.13393 10.4264 9.05357 10.3299 9.05357V9.05357ZM8.85671 12.2464H7.19064V9.225C7.19064 9.12857 7.11564 9.05357 7.01922 9.05357H6.4085C6.31207 9.05357 6.23707 9.12857 6.23707 9.225V13.0339C6.23707 13.0821 6.25314 13.1196 6.28529 13.1518C6.31743 13.1786 6.35493 13.2 6.40314 13.2H8.85136C8.94778 13.2 9.02278 13.125 9.02278 13.0286V12.4179C9.02278 12.3268 8.94779 12.2464 8.85671 12.2464V12.2464ZM17.9371 9.05357H15.4888C15.3978 9.05357 15.3174 9.12857 15.3174 9.225V13.0339C15.3174 13.125 15.3924 13.2054 15.4888 13.2054H17.9371C18.0335 13.2054 18.1085 13.1304 18.1085 13.0339V12.4232C18.1085 12.3268 18.0335 12.2518 17.9371 12.2518H16.271V11.6089H17.9371C18.0335 11.6089 18.1085 11.5339 18.1085 11.4375V10.8214C18.1085 10.725 18.0335 10.65 17.9371 10.65H16.271V10.0071H17.9371C18.0335 10.0071 18.1085 9.93215 18.1085 9.83572V9.225C18.1031 9.13393 18.0281 9.05357 17.9371 9.05357V9.05357ZM24.146 4.37679V19.6607C24.1406 22.0607 22.1746 24.0053 19.7692 24H4.48529C2.08529 23.9946 0.14065 22.0232 0.146007 19.6232V4.33929C0.151364 1.93929 2.12279 -0.0053461 4.52279 1.10419e-05H19.8067C22.2067 0.00536818 24.1513 1.97144 24.146 4.37679ZM20.846 10.9446C20.846 7.03393 16.9246 3.85179 12.1085 3.85179C7.29243 3.85179 3.371 7.03393 3.371 10.9446C3.371 14.4482 6.47814 17.3839 10.6781 17.9411C11.7014 18.1607 11.5835 18.5357 11.3531 19.9125C11.3156 20.1321 11.1764 20.775 12.1085 20.3839C13.0406 19.9928 17.1388 17.4214 18.9763 15.3107C20.2406 13.9179 20.846 12.5089 20.846 10.9446Z" fill="currentColor">
        </path></svg>
                            LINE
                        </button>

                    </div>
                </div>

                <!-- 2. 帳號密碼登入表單 -->
                <h2>會員登入</h2>
                <form @submit.prevent="handleLogin">
                    <div class="form-group">
                        <label for="account">手機號碼</label>
                        <input 
                          type="text" 
                          inputmode="numeric" 
                          id="account" 
                          v-model="account" 
                          placeholder="輸入您的註冊手機" 
                          required 
                        />
                    </div>
                    <div class="form-group">
                        <label for="password">密碼</label>
                        <input 
                          type="password" 
                          id="password" 
                          v-model="password" 
                          placeholder="輸入密碼" 
                          required 
                        />
                    </div>

                    <!-- 錯誤訊息顯示 -->
                    <div v-if="message" class="error-message">
                        {{ message }}
                    </div>

                    <button type="submit" class="submit-btn">登入</button>
                </form>

                <!-- 3. 忘記密碼 / 註冊連結 -->
                <div class="login-links">
                    <router-link to="/fpassword">忘記密碼？</router-link>
                    <router-link to="/register">還沒有帳號？立即註冊</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted , defineOptions } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import axios from 'axios'
import { usePageStore } from '@/store/pageStore.js'

// 給組件命名（Vue 3.3+ 可使用 defineOptions）
defineOptions({
  name: 'LoginPage'
})

// =====================
// 1. 取代 data()
// =====================
const account = ref('')
const password = ref('')
const message = ref('')
const loginImg = ref('')

// template 裡的 ref
const loginBlock = ref(null)

// =====================
// 2. 取得 store 及 router
// =====================
const store = useStore()
const router = useRouter()

// =====================
// 3. 取代 computed
// =====================
//const imagePath = computed(() => store.getters.imagePath)
const redirectPath = computed(() => store.state.redirectPath)

// =====================
// 4. 取代 methods
// =====================

// 4-1. 提交 mutation (原本 mapMutations)
function setRedirectPath(path) {
  store.commit('setRedirectPath', path)
}
function setLoggedIn(isLoggedIn) {
  store.commit('setLoggedIn', isLoggedIn)
}
function setUserProfile(profile) {
  store.commit('setUserProfile', profile)
}

// 4-2. 處理登入成功
function handleLoginSuccess(response) {
  setLoggedIn(true)
  setUserProfile(response.data.user)

  // 若有預先儲存的導向路徑，先導向該路徑
  if (redirectPath.value) {
    router.push(redirectPath.value)
    setRedirectPath(null)
    return
  }

  // 若基本資料不完整，導向個人資訊頁
  const user = response.data.user
  if (
    !user.username ||
    !user.birthday ||
    !user.phone ||
    !user.email
  ) {
    router.push('/profile')
  } else {
    // 否則回首頁
    router.push('/')
  }
}

// 4-3. 一般登入
function handleLogin() {
  axios
    .post('/api/login/basic-login', {
      account: account.value,
      password: password.value,
    })
    .then((response) => {
      if (response.data.success) {
        handleLoginSuccess(response)
      } else {
        message.value = response.data.message
      }
    })
    .catch((error) => {
      console.error(error)
      message.value = '登入失敗，請確認帳號密碼。'
    })
}

// 4-4. 產生隨機 state
function randomState() {
  const randomBytes = new Uint8Array(20)
  window.crypto.getRandomValues(randomBytes)
  return encodeURIComponent(
    Array.from(randomBytes)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('')
  )
}

// 4-5. LINE Login
function handleLineLogin() {
  const clientId = process.env.VUE_APP_LINE_CLIENT_ID
  const redirectUri = encodeURIComponent(process.env.VUE_APP_LINE_REDIRECT_URL)
  const scope = encodeURIComponent('openid profile email')
  const state = randomState()

  axios
    .post('/api/login/state-save', { state })
    .then((res) => {
      if (res.data.success) {
        const lineLoginUrl =
            'https://access.line.me/oauth2/v2.1/authorize?' +
            `response_type=code` +
            `&client_id=${clientId}` +
            `&redirect_uri=${redirectUri}` +
            `&state=${state}` +
            `&scope=${scope}` +
            `&bot_prompt=normal` +
            `&prompt=consent`
        window.location.href = lineLoginUrl
      }
    })
    .catch((error) => console.error(error))
}

// 4-6. Facebook Login
// function handleFacebookLogin() {
//   const appId = process.env.VUE_APP_FACEBOOK_APP_ID
//   const redirectUri = encodeURIComponent(process.env.VUE_APP_FACEBOOK_REDIRECT_URL)
//   const scope = encodeURIComponent('email public_profile')
//   const state = randomState()

//   axios
//     .post('/api/login/state-save', { state })
//     .then((res) => {
//       if (res.data.success) {
//         const fbAuthUrl =
//           `https://www.facebook.com/v14.0/dialog/oauth` +
//           `?client_id=${appId}` +
//           `&redirect_uri=${redirectUri}` +
//           `&state=${state}` +
//           `&scope=${scope}`
//         window.location.href = fbAuthUrl
//       }
//     })
//     .catch((error) => console.error('State save error:', error))
// }

// 4-7. Google Login
function handleGoogleAuthCodeLogin() {
  const clientId = process.env.VUE_APP_GOOGLE_CODE
  const redirectUri = encodeURIComponent(process.env.VUE_APP_GOOGLE_REDIRECT_URL)
  const scope = encodeURIComponent('email profile')
  const state = randomState()

  axios
    .post('/api/login/state-save', { state })
    .then((res) => {
      if (res.data.success) {
        const oauthUrl =
          'https://accounts.google.com/o/oauth2/v2/auth' +
          `?client_id=${clientId}` +
          `&redirect_uri=${redirectUri}` +
          `&scope=${scope}` +
          `&state=${state}` +
          `&response_type=code`
        window.location.href = oauthUrl
      }
    })
    .catch((error) => console.error(error))
}

// =====================
// 5. 取代 created、mounted
// =====================
onMounted(async () => {

 const pageStore = usePageStore()
  await pageStore.fetchCheckLoginImg();
  loginImg.value = pageStore.loginImg;


  // IntersectionObserver：整個卡片的淡入 + 3D翻轉一點點
  const container = loginBlock.value
  if (!container) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('container-visible')
        }
      })
    },
    { threshold: 0.1 }
  )
  observer.observe(container)
})
</script>

<style scoped>
.floating-icon {
    width: 35px;
    height: 35px;
    fill: currentColor;
}
/* 外層容器 + 3D 效果 */
.login-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;

    opacity: 0;
    /* 預設透明 */
    transform: translateY(50px) rotateX(8deg);
    transform-origin: top;
    transition: opacity 1.2s ease, transform 1.2s ease;
    perspective: 800px;
    /* 父容器的3D視角 */
}

.login-container.container-visible {
    opacity: 1;
    transform: translateY(0) rotateX(0);
}

.login-card {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 30px;

    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
    padding: 30px;

    /* 動畫預設：先淡出下移 */
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.8s ease, transform 0.8s ease;
}

.container-visible .login-card {
    opacity: 1;
    transform: translateY(0);
}

/* 左右分塊 */
.login-left,
.login-right {
    flex: 1;
    min-width: 300px;
}

/* 左側內容 */
.login-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.login-left h1 {
    font-size: 2rem;
    margin-bottom: 10px;
}

.login-left p {
    font-size: 1rem;
    line-height: 1.5;
}

.login-image {
    width: 100%;
    max-width: 220px;
    margin-top: 20px;
    object-fit: cover;
    border: 5px solid #fff;
    border-radius: 10px;
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.3);
    transition: transform 0.3s ease;
    transform: rotateX(10deg);
    transform-origin: center bottom;
}

.login-image:hover {
    transform: rotateX(0deg);
}

/* 右側：整合「快速登入 + 帳密登入」 */
.login-right {
    display: flex;
    flex-direction: column;
}

/* 快速登入區 */
.quick-login {
    margin-bottom: 20px;
    /* 在手機版排最上面 (見 @media 下的 order 設定) */
}

.quick-login h3 {
    margin-bottom: 10px;
}

.quick-login-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
}

/* 帳號密碼表單 */
.login-right h2 {
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
}

label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

input {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1rem;
}

.error-message {
    color: red;
    margin-top: 5px;
}

.submit-btn {
    display: inline-block;
    padding: 10px 20px;
    background-color: #27ae60;
    /* 綠色 */
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
    transition: background-color 0.3s ease, transform 0.3s ease;
    margin-top: 10px;
}

.submit-btn:hover {
    background-color: #f39c12;
    transform: scale(1.05);
}

/* 忘記密碼 / 註冊連結 */
.login-links {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
}

.login-links a {
    color: #007bff;
    text-decoration: none;
    font-size: 0.9rem;
}

.login-links a:hover {
    text-decoration: underline;
}

/* 社群登入按鈕 (FB/LINE/Google) */
.social-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 15px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #fff;
    font-size: 1rem;
    transition: transform 0.3s ease;
}

.social-btn:hover {
    transform: scale(1.05);
}

.fb-btn {
    background-color: #3b5998;
}

.line-btn {
    background-color: #00c300;
    /* LINE 綠 */
}

.google-btn {
    background-color: #db4437;
    /* Google 紅 */
}

.iconify,
.NEH9Ef {
    font-size: 16px;
    /* svg 大小微調 */
}

/* 手機板：將 quick-login 排在最上面 (order: -1) */
@media (max-width: 768px) {
    .login-card {
        flex-direction: column;
    }

    /* 關鍵：把 login-right 放在上面 (order較小)；login-left 放在下面 (order較大) */
    .login-right {
        order: 1;
    }

    .login-left {
        order: 2;
    }

    .login-left,
    .login-right {
        min-width: 100%;
    }

    /* 在小螢幕時，讓 quick-login 排在表單之前 */
    .login-right {
        display: flex;
        flex-direction: column;
    }

    .quick-login {
        order: -1;
        /* 關鍵：先顯示「快速登入」 */
        margin-bottom: 1rem;
        text-align: left;
        /* 新增這行 */
    }

    .quick-login-buttons {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: flex-start;
        /* 確保按鈕靠左對齊 */
    }

    .social-btn {
        flex: 1 1 auto;
        min-width: 100px;
        max-width: 150px;
        font-size: 1.2rem;
        /* 調整按鈕文字大小 */
        padding: 12px 20px;
        /* 調整按鈕內邊距 */
    }

    .social-btn img,
    .social-btn svg {
        width: 24px;
        /* 調整圖示大小 */
        height: 24px;
    }

    .login-links {
        flex-direction: column;
        align-items: flex-start;
    }

    .login-left h1 {
        font-size: 2.0rem;
    }

    .login-right h2 {
        font-size: 2.0rem;
    }

    h3 {
        font-size: 2.0rem;
    }

    /* 調整整體文字大小 */
    .login-container,
    .login-card,
    .login-left p,
    .form-group label,
    .form-group input,
    .submit-btn,
    .login-links a {
        font-size: 1.5rem;
        /* 調整整體文字大小 */
    }
}
</style>
